module.exports = __webpack_public_path__ + "static/portrait-7ee4398e3730a700595b06a72736396d.jpg";